module.exports = "<div class=\"m-label-content\">\n   {{{info}}}\n</div>";